import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApmBase } from '@elastic/apm-rum';
import { ApmService } from '@elastic/apm-rum-angular';

@Injectable()
export class SessionIdInterceptor implements HttpInterceptor {
    apmInstance: ApmBase;
    constructor(private elasticAPMService: ApmService) { 
        this.apmInstance = this.elasticAPMService.apm;
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.body && req.body !== null) {
            this.apmInstance?.addLabels({
                httpRequestPayload: JSON.stringify(req.body)
            });
        }
        const sessionId = sessionStorage.getItem('ecolab.envision_elasticAPMUserSessionId');
        if (sessionId) {
            const cloned = req.clone({
                setHeaders: {
                    'Session-Id': sessionId
                }
            });
            return next.handle(cloned);
        }
        return next.handle(req);
    }
}